/**
 * Save a Blob to the user's device via a temporary object URL + synthetic
 * anchor click. Used for authenticated binary downloads (e.g. накладная PDFs)
 * that come back through the axios `api` instance as blobs.
 */
export function triggerBlobDownload(blob: Blob, filename: string): void {
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  // Revoke on the next tick so the click has taken effect.
  setTimeout(() => URL.revokeObjectURL(url), 0);
}

/** Extract the filename from a Content-Disposition header, preferring the
 * RFC 5987 `filename*=UTF-8''…` form. Returns null when absent/unparseable. */
export function filenameFromContentDisposition(header: string | undefined): string | null {
  if (!header) return null;
  const star = /filename\*=UTF-8''([^;]+)/i.exec(header);
  if (star?.[1]) {
    try {
      return decodeURIComponent(star[1]);
    } catch {
      /* fall through to the plain form */
    }
  }
  const plain = /filename="?([^";]+)"?/i.exec(header);
  return plain?.[1] ?? null;
}
